import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache — survives re-renders / re-mounts (e.g. user navigating
// Home → Product → Home) so we don't refetch the full catalog every time.
let _cache = null;        // last successful payload
let _inflight = null;     // shared promise to dedupe concurrent fetches
const TTL_MS = 5 * 60 * 1000; // 5 min

const fetchCatalog = () => {
  if (_inflight) return _inflight;
  _inflight = Promise.all([
    axios.get(`${API}/catalog`),
    axios.get(`${API}/products/featured`),
  ])
    .then(([catalogRes, featuredRes]) => {
      _cache = {
        ts: Date.now(),
        catalog: catalogRes.data || [],
        featured: featuredRes.data || [],
      };
      _inflight = null;
      return _cache;
    })
    .catch((e) => {
      _inflight = null;
      throw e;
    });
  return _inflight;
};

export const useCatalog = () => {
  const fresh = _cache && Date.now() - _cache.ts < TTL_MS;
  const [data, setData] = useState(
    fresh
      ? { catalog: _cache.catalog, featured: _cache.featured, loading: false, error: null }
      : { catalog: [], featured: [], loading: true, error: null }
  );

  useEffect(() => {
    if (fresh) return;
    let cancelled = false;
    fetchCatalog()
      .then((res) => {
        if (cancelled) return;
        setData({ catalog: res.catalog, featured: res.featured, loading: false, error: null });
      })
      .catch((e) => {
        if (cancelled) return;
        setData({ catalog: [], featured: [], loading: false, error: e.message });
      });
    return () => { cancelled = true; };
  }, [fresh]);

  return data;
};
